import {
  Cars64,
  HouseDIY64,
  Animals64,
  SportsHobbies64,
  Electronics64,
  ClothesLifestyle64,
  CarsMotors64,
  Farming64,
  BabyKids64,
  Business64,
  HolidaysTickets64,
  LostFound64,
  MusicEducation64,
  Property64,
  ServicesForHire64,
  AllCarsMotors64,
} from '../../../components/Toolkit/Base64/Sections';

export interface Map {
  [name: string]: JSX.Element;
}

const MarketplaceIcons: Map = {
  cars: <Cars64 />,
  household: <HouseDIY64 />,
  animals: <Animals64 />,
  sport: <SportsHobbies64 />,
  homeelectronics: <Electronics64 />,
  fashion: <ClothesLifestyle64 />,
  motor: <CarsMotors64 />,
  farming: <Farming64 />,
  babyandkids: <BabyKids64 />,
  business: <Business64 />,
  tickets: <HolidaysTickets64 />,
  lostfound: <LostFound64 />,
  music: <MusicEducation64 />,
  property: <Property64 />,
  'services-for-hire': <ServicesForHire64 />,
  all: <AllCarsMotors64 />,
};

export default MarketplaceIcons;
